import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { consumeResumeAfterAuth } from '@/utils/pendingCheckout';
import { startPaidCheckout } from '@/utils/startCheckout';

/**
 * After login from a paywall/pricing CTA (Google or email),
 * resume the checkout the user originally intended to start.
 */
const CheckoutResumer = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const ran = useRef(false);

  useEffect(() => {
    if (loading || !user || ran.current) return;
    if (/\/(payment-success|payment-cancel)(\/|$)/i.test(location.pathname)) return;

    const intent = consumeResumeAfterAuth();
    if (!intent) return;
    ran.current = true;

    void (async () => {
      const result = await startPaidCheckout({
        planId: intent.planId,
        billing: intent.billing,
        provider: intent.provider,
        lang: intent.lang,
        resumeAfterAuth: false,
      });
      if (!result.ok) toast.error(result.message);
    })();
  }, [user, loading, location.pathname]);

  return null;
};

export default CheckoutResumer;
